(function () {
  if (window.__nvMenu) return;
  window.__nvMenu = true;

  var wide = window.matchMedia('(min-width: 1200px)');

  function setup(dialog) {
    if (!dialog || dialog.__ready) return;
    dialog.__ready = true;

    var root = dialog.querySelector('[data-nvm-root]');
    var views = Array.prototype.slice.call(dialog.querySelectorAll('.nvm__view'));
    var current = root;
    var opener = null;
    var subOpener = null;

    function show(view, focusTarget) {
      views.forEach(function (item) {
        var active = item === view;
        item.classList.toggle('is-active', active);
        item.inert = !active;
      });
      current = view;
      if (focusTarget) focusTarget.focus({ preventScroll: true });
    }

    function openSub(button) {
      var view = dialog.querySelector('#' + button.getAttribute('aria-controls'));
      if (!view) return;
      subOpener = button;
      button.setAttribute('aria-expanded', 'true');
      view.scrollTop = 0;
      show(view, view.querySelector('[data-nvm-back]'));
    }

    function back() {
      if (current === root) return;
      if (subOpener) subOpener.setAttribute('aria-expanded', 'false');
      show(root, subOpener);
    }

    dialog.__open = function (trigger) {
      if (dialog.open) return;
      opener = trigger || null;
      show(root);
      dialog.showModal();
      if (opener) opener.setAttribute('aria-expanded', 'true');
    };

    function close() {
      if (dialog.open) dialog.close();
    }

    dialog.addEventListener('close', function () {
      if (opener) opener.setAttribute('aria-expanded', 'false');
      // Back to the top level once the panel has slid away.
      window.setTimeout(function () {
        if (dialog.open) return;
        if (subOpener) subOpener.setAttribute('aria-expanded', 'false');
        show(root);
      }, 360);
    });

    // Escape steps back out of a sub-menu before it closes the panel.
    dialog.addEventListener('cancel', function (event) {
      if (current !== root) {
        event.preventDefault();
        back();
      }
    });

    dialog.addEventListener('click', function (event) {
      if (event.target.closest('[data-nvm-close]')) { close(); return; }
      if (event.target.closest('[data-nvm-back]')) { back(); return; }
      var subButton = event.target.closest('[data-nvm-open]');
      if (subButton) { openSub(subButton); return; }
      if (event.target === dialog) {
        var box = dialog.getBoundingClientRect();
        var outside = event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom;
        if (outside) close();
      }
    });

    wide.addEventListener('change', function (event) { if (event.matches) close(); });
    window.addEventListener('pageshow', function (event) { if (event.persisted) close(); });
  }

  // The header's own menu button opens this panel instead of the theme drawer.
  // Capturing at the document stops the theme's drawer handler from running.
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.header__icon--menu');
    if (!trigger || wide.matches) return;
    var dialog = document.querySelector('[data-nvm]');
    if (!dialog) return;
    setup(dialog);
    event.preventDefault();
    event.stopPropagation();
    var details = trigger.closest('details');
    if (details) details.removeAttribute('open');
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-controls', dialog.id);
    dialog.__open(trigger);
  }, true);

  function init() { setup(document.querySelector('[data-nvm]')); }
  init();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
